var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-row',_vm._l((_vm.quarters),function(quarter){return _c('w-col',{key:quarter,attrs:{"md":"6"}},[_c('w-radio',{attrs:{"name":_vm.uid,"element-value":`${quarter}`,"checked":_vm.isChecked(quarter),"label":_vm.$ct(`quarter.${quarter}`)},on:{"input":function($event){return _vm.setQuarter(quarter)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }